//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'hmSetting',
  props: {
    value: {
      type: Object,
      return: function _return() {}
    },
    edit: Boolean
  },
  data: function data() {
    return {
      imgSrc: 'https://res.youlianfuwu.com/voucher/shop/hmcs_info.jpg',
      imgStyle: {
        width: '220px',
        height: '100px',
        marginTop: '10px'
      },
      list: [{
        name: '默认规则',
        id: 0
      }, {
        name: '个性化',
        id: 1
      }]
    };
  },
  mounted: function mounted() {
    if (this.value.hm_rule_type === 0) {
      this.changeType(0);
    }
  },
  methods: {
    changeType: function changeType(type) {
      if (type === 1) {
        this.value.hm_tip_content = '';
      } else {
        this.value.hm_tip_content = this.value.hm_default_tip_content;
      }
    }
  }
};